import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

interface PenaltiesProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  currentTierIndex?: number | null;
}

export const tiers = [
  { amount: 40, dsTier: "-", innerTier: "Fight Club" },
  { amount: 80, dsTier: "Bronze", innerTier: "Fight Club" },
  { amount: 200, dsTier: "Silver", innerTier: "Fight Club" },
  { amount: 400, dsTier: "Gold", innerTier: "Fight Club" },
  { amount: 800, dsTier: "Platinum", innerTier: "Beach Club" },
  { amount: 4000, dsTier: "Champion", innerTier: "Beach Club" },
  { amount: 10000, dsTier: "Champion", innerTier: "Gentlement Club" },
  { amount: 40000, dsTier: "Champion", innerTier: "Diamond Club" },
];

export const TiersModal = (props: PenaltiesProps) => {
  const { open, setOpen, currentTierIndex } = props;
  const theme = useTheme();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={() => setOpen(false)}
      ModalProps={{
        keepMounted: true,
        BackdropProps: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0,0,0,0.55)",
          },
        },
      }}
      PaperProps={{
        sx: {
          maxWidth: 1100,
          mx: "auto",
          mb: { xs: 1, sm: 2 },
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: "background.paper",
          p: 3,
        },
      }}
    >
      <Box sx={{ mx: "auto", mb: 1.5, height: 6, width: 56, borderRadius: 999, bgcolor: "action.selected" }} />

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Access Tiers</Typography>
          <Typography variant="body2" color="text.secondary">
            Membership levels by staked DD amount.
          </Typography>
        </Box>
        <IconButton onClick={() => setOpen(false)} aria-label="Close tiers drawer">
          <CloseIcon />
        </IconButton>
      </Box>

      <Paper variant="outlined" sx={{ overflow: "hidden", borderRadius: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Amount (DD)</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>DuckSTARTER</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Inner Circle</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tiers.map((tier, index) => (
              <TableRow
                key={`${tier.amount}-${tier.innerTier}`}
                sx={index === currentTierIndex ? { bgcolor: "primary.main", "& td": { color: "primary.contrastText" } } : undefined}
              >
                <TableCell sx={{ fontWeight: 500 }}>{tier.amount.toLocaleString()}</TableCell>
                <TableCell>
                  {tier.dsTier}
                  {index === currentTierIndex ? (
                    <Box component="span" sx={{ ml: 1, px: 1, py: 0.25, borderRadius: 99, fontSize: 10, fontWeight: 700, letterSpacing: 0.4, bgcolor: "rgba(0,0,0,0.22)", color: "inherit" }}>
                      YOU ARE HERE
                    </Box>
                  ) : null}
                </TableCell>
                <TableCell>{tier.innerTier}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Drawer>
  );
};
